import CustomLink from '@/components/shared/custom/custom-link';
import { Rutas } from '@/constants/rutas';
import { Box, Button, Typography, useMediaQuery, useTheme } from '@mui/material';

const PlayersSeasonSelector = ({ player, slug }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    if (!player?.seasons) return null;

    return (
        <Box width={'100%'} display="flex" flexDirection="column">
            <Typography variant="h2" fontWeight={500} mb={1}>
                Temporadas de La Liga Fantasy Dazn
            </Typography>
            <Box
                mb={2}
                display="flex"
                flexWrap="wrap"
                justifyContent={isMobile ? 'space-between' : 'flex-start'}
                width="100%"
                gap={1}
            >
                {player.seasons.map((season) => {
                    const isSelected = season === player.season;

                    return (
                        <CustomLink
                            href={`${Rutas.JUGADORES}/puntos-la-liga-fantasy/${slug}/${season}`}
                            disableLink={player.seasons?.length < 2}
                            key={season}
                        >
                            <Button
                                key={season}
                                variant={isSelected ? 'contained' : 'outlined'}
                                color="primary"
                                disabled={player.seasons?.length < 2}
                                sx={{
                                    width: isMobile
                                        ? `calc(50% - ${1 / 2}rem)` // Restamos la mitad del gap (1rem/2)
                                        : '200px',
                                }}
                            >
                                {season}
                            </Button>
                        </CustomLink>
                    );
                })}
            </Box>
        </Box>
    );
};

export default PlayersSeasonSelector;
